import type { IEquipoEscalera } from '../../../modelos/CotizadorNBS/entidades/IEquipoEscalera';
import type { IEspecificacionesEscalera } from '../../../modelos/CotizadorNBS/entidades/IEspecificacionesEscalera';
import {
    especificacionesDesdeApi,
    validarEquipo,
    type ICampoDato,
    type ISeccionEspecificaciones,
    type ValorEspecificacion
} from './camposEspecificacion';

/** Largo máximo de los textos: igual a EspecificacionesEscalera.LargoTexto en el back. */
export const LARGO_TEXTO_ESPECIFICACION_ESCALERA = 100;

/**
 * Pestañas de especificaciones de escaleras y rampas: las filas de la tabla de especificaciones de escaleras del
 * documento de requerimientos (sección 5) que no están en "Datos del equipo". Las imágenes del documento solo van en el
 * PDF. Por ahora todas son obligatorias, como en ascensores (pendiente que el cliente lo confirme).
 */
export const SECCIONES_ESPECIFICACIONES_ESCALERA: ISeccionEspecificaciones<IEspecificacionesEscalera>[] = [
    {
        clave: 'especificaciones',
        titulo: 'Especificaciones Técnicas',
        campos: [
            { campo: 'Marca', etiqueta: 'Marca', tipo: 'texto' },
            { campo: 'NormaTecnica', etiqueta: 'Norma técnica', tipo: 'texto' },
            { campo: 'Uso', etiqueta: 'Uso', tipo: 'texto' },
            { campo: 'CapacidadPersonasHora', etiqueta: 'Capacidad (personas/hora)', tipo: 'entero' },
            { campo: 'LongitudMm', etiqueta: 'Longitud', tipo: 'mm' },
            { campo: 'AccesoEmbarque', etiqueta: 'Acceso y embarque', tipo: 'texto' },
            { campo: 'PitAnchoMm', etiqueta: 'Pit: ancho', tipo: 'mm' },
            { campo: 'PitLargoMm', etiqueta: 'Pit: largo', tipo: 'mm' },
            { campo: 'PitProfundoMm', etiqueta: 'Pit: profundo', tipo: 'mm' },
            { campo: 'SistemaAhorroEnergia', etiqueta: 'Sistema de ahorro de energía', tipo: 'texto' },
            { campo: 'TipoMotor', etiqueta: 'Tipo de motor', tipo: 'texto' },
            { campo: 'CuartoMaquinas', etiqueta: 'Cuarto de máquinas', tipo: 'texto' },
            { campo: 'TipoOperacion', etiqueta: 'Tipo de operación', tipo: 'texto' },
            { campo: 'AmbienteTrabajo', etiqueta: 'Ambiente de trabajo', tipo: 'texto' }
        ]
    },
    {
        clave: 'acabados',
        titulo: 'Acabados',
        campos: [
            { campo: 'MaterialPaso', etiqueta: 'Material del paso', tipo: 'texto' },
            { campo: 'Demarcacion', etiqueta: 'Demarcación', tipo: 'texto' },
            { campo: 'ColorBandas', etiqueta: 'Color de bandas', tipo: 'texto' },
            { campo: 'Iluminacion', etiqueta: 'Iluminación', tipo: 'texto' }
        ]
    }
];

export const estadoInicialEspecificacionesEscalera: IEspecificacionesEscalera = {
    Marca: '', NormaTecnica: '', Uso: '', CapacidadPersonasHora: null, LongitudMm: null, PitAnchoMm: null, PitLargoMm: null,
    PitProfundoMm: null, SistemaAhorroEnergia: '', TipoMotor: '', CuartoMaquinas: '', TipoOperacion: '', ColorBandas: '',
    Iluminacion: '', MaterialPaso: '', Demarcacion: '', AccesoEmbarque: '', AmbienteTrabajo: ''
};

/** Especificaciones de la escalera que vienen del back (textos en null pasan a vacío). */
export const especificacionesEscaleraDesdeApi = (api?: Partial<Record<keyof IEspecificacionesEscalera, ValorEspecificacion>>) =>
    especificacionesDesdeApi(SECCIONES_ESPECIFICACIONES_ESCALERA, estadoInicialEspecificacionesEscalera, api);

/** Campos de la pestaña "Datos del equipo" de la escalera. Todos obligatorios. */
const CAMPOS_DATOS_ESCALERA: ICampoDato<IEquipoEscalera>[] = [
    { campo: 'Nombre', etiqueta: 'Nombre' }, { campo: 'Tipo', etiqueta: 'Tipo' }, { campo: 'Producto', etiqueta: 'Modelo' },
    { campo: 'Contenedores', etiqueta: 'Contenedores', admiteCero: true }, { campo: 'VelocidadIngreso', etiqueta: 'Velocidad' },
    { campo: 'Altura', etiqueta: 'Altura' }, { campo: 'AnchoPasos', etiqueta: 'Ancho de pasos' }, { campo: 'Inclinacion', etiqueta: 'Inclinación' },
    { campo: 'PotenciaMotor', etiqueta: 'Potencia Motor' }, { campo: 'Cantidad', etiqueta: 'Cantidad' },
    { campo: 'CostoFCA', etiqueta: 'Costo Equipo', admiteCero: true }
];

/** Campos obligatorios de la escalera sin diligenciar, separados por pestaña. */
export const validarEscalera = (form: Partial<IEquipoEscalera>) =>
    validarEquipo(form, CAMPOS_DATOS_ESCALERA, SECCIONES_ESPECIFICACIONES_ESCALERA,
        form.Especificaciones ?? estadoInicialEspecificacionesEscalera);
